module.exports = __webpack_public_path__ + "img/value_creation.8f8afa2e.png";